// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text[data-v-74d5bb10]{\r\n\tfont-size: 1.1em;\r\n\tfont-weight: 400;\r\n\tcolor:black;\n}\n.text.gray[data-v-74d5bb10]{\r\n\tfont-size: 15px;\r\n\tcolor: var(--main-gray-5);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
